import React from "react";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <div className="footer">
      <div className="copyright">
        <p>
          Copyright © Designed &amp; Developed by{" "}
          <a href="https://www.sanjeevitechnologies.com/index.html" target="_blank" rel="noreferrer">
            Sanjeevi Technology Solutions
          </a>{" "}
         {currentYear}
        </p>
      </div>
    </div>
  );
};

export default Footer;
